import React from 'react';
import { Typography } from '../../../../typography';
import { mergeSx } from '../../../../../utils/sx/merge';
import { IconContainer } from '../../iconContainer';
import { PlusIcon } from '../../../../../icons';
import { AvatarTokens } from '../../../const';
import { ProfileLettersProps } from './model';
import { LETTERS_SIZE_TO_CONTAINER_SIZE_RATE, PLUS_ICON_SIZE_TO_CONTAINER_SIZE } from './const';

export const AvatarLettersContent: React.FC<ProfileLettersProps> = ({ theme, backgroundColor, letters, color, clickAction }) => {
  return (
    <IconContainer
      sx={{
        backgroundColor: backgroundColor ?? 'peach',
      }}
      theme={theme}
    >
      {clickAction === 'change' ? (
        <PlusIcon sx={{ fontSize: `calc(${AvatarTokens.Size('100px')} * ${PLUS_ICON_SIZE_TO_CONTAINER_SIZE})` }} />
      ) : (
        <Typography
          sx={mergeSx(
            { color: color && typeof theme.palette[color] === 'string' ? (theme.palette[color] as string) : 'white' },
            { fontSize: `calc(${AvatarTokens.Size('100px')} * ${LETTERS_SIZE_TO_CONTAINER_SIZE_RATE})` },
          )}
          variant="h6"
        >
          {letters.toUpperCase()}
        </Typography>
      )}
    </IconContainer>
  );
};
